import JobForm from './job-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
import EditForm from '@/components/refinedev/pages/edit-form';

const JobEdit = () => {
  return (
    <EditForm transformBeforeSave={JobForm.transformBeforeSave}>
      <JobForm />
      <SaveButton className="mt-2" />
    </EditForm>
  );
};

export default JobEdit;
